import React from "react";

const LoadingCoupons = () => {

    return (

        <div className="loading-coupons">

            {[1,2,3,4,5].map((item)=>(
                <div
                    key={item}
                    className="loading-card"
                />
            ))}

        </div>

    );

};

export default LoadingCoupons;